import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { SalesProductType } from '../sales-product-type';

@Injectable({
  providedIn: 'root'
})
export class ProductTypeService {

  constructor() { }


  public setDefaultProductTypeDescription(productType: SalesProductType, index: number, formGroup: FormGroup, languageId: number) {
    let selectedDescription = this.getSalesProductTypeDefaultDescription(productType, languageId);
    if (selectedDescription != null) {
      let productFormArray = formGroup.get("products") as FormArray;
      if (productFormArray == null || productFormArray == undefined) {
        return ;
      }
      let product = productFormArray.controls[index];
      if (product.get("description") == null || product.get("description") == undefined) {
        return ;
      }
      product.get("description")!.setValue(selectedDescription);
    }
  }

  private getSalesProductTypeDefaultDescription(productType: SalesProductType, languageId: number) {
    switch (languageId) {
      case 1:
        return productType.defaultDescriptionFr;
      case 2:
        return productType.defaultDescriptionEn;
      case 3:
        return productType.defaultDescriptionNl;
      case 4:
        return productType.defaultDescriptionNl;
      case 5:
        return productType.defaultDescriptionPt;
      default:
        return null;
    }
  }
}
